import { format } from "date-fns";
import { DATE_FORMAT_SHORT } from "./dateConstants";

export const transformToShortDate = (date: string) => {
  return format(new Date(date), DATE_FORMAT_SHORT);
};
